<script setup lang="ts">
  import Button from '@leaflink/stash/Button.vue';
  import { onBeforeMount, ref } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  import { ROUTE_NAMES } from '@/constants';
  import { useUserStore } from '@/piniaStores/user/user.store';
  import { i18n } from '@/plugins';
  import { trackWithSegment } from '@/segment';

  const { user, fetchUser } = useUserStore();
  const router = useRouter();
  const route = useRoute();

  const isRedirecting = ref<boolean>(false);

  interface StartFreeTrialButtonProps {
    location?: 'Header' | 'Plans' | 'Footer';
    isLoading?: boolean;
  }

  const props = defineProps<StartFreeTrialButtonProps>();

  async function handleStartFreeTrial() {
    isRedirecting.value = true;
    const companySlug = user.companies.find((company) => company.id === user.activeCompanyId)?.slug;

    if (props.location) {
      trackWithSegment({
        event: 'plusMembershipClicked',
        properties: {
          product_name: 'LeafLink Plus',
          element_engaged: `Start Free Trial - ${props.location}`,
          page_engaged_from: 'Compare Plans',
          page_navigated_to: "What You'll Need",
        },
      });
    }

    await router.push({
      name: ROUTE_NAMES.INVENTORY_INSIGHTS_ENROLLMENT,
      params: { company: companySlug },
      query: {
        previous: route.query.previous,
      },
    });

    isRedirecting.value = false;
  }

  onBeforeMount(async () => {
    await fetchUser();
  });
</script>

<template>
  <Button
    class="tw-rounded-full tw-text-xl tw-py-3"
    color="blue"
    :is-loading="isRedirecting || props.isLoading"
    @click="handleStartFreeTrial"
  >
    <slot>{{ i18n.t('inventoryInsights.startFreeTrial') }}</slot>
  </Button>
</template>
